import { render, staticRenderFns } from "./DomainForm.vue?vue&type=template&id=02459ae0&scoped=true"
import script from "./DomainForm.vue?vue&type=script&lang=js"
export * from "./DomainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02459ae0",
  null
  
)

export default component.exports